import { render } from "./GroupCard.vue?vue&type=template&id=f778523e&scoped=true"
import script from "./GroupCard.vue?vue&type=script&lang=js"
export * from "./GroupCard.vue?vue&type=script&lang=js"

import "./GroupCard.vue?vue&type=style&index=0&id=f778523e&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f778523e"]])

export default __exports__